import baseAPI from '@/api/base';
import { EditProjectTransaction, GetProjectTransaction, RegisterProjectTransaction } from '@/dtos/project_transaction.dto';
import {
  DELETE_PROJECT_TRANSACTION_URL,
  EDIT_PROJECT_TRANSACTION_URL,
  GET_PROJECT_TRANSACTION_URL,
  GET_PROJECT_TRANSACTION_STATS_URL,
  REGISTER_PROJECT_TRANSACTION_URL,
  TOGGLE_PROJECT_TRANSACTION_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class ProjectTransaction {
  static getProjectTransactions = async (getProjectTransaction: GetProjectTransaction): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_PROJECT_TRANSACTION_URL, {
      params: getProjectTransaction,
    });
    console.log('response', response);
    return response;
  };

  static registerProjectTransaction = async (
    registerProjectTransaction: RegisterProjectTransaction | FormData
  ): Promise<AxiosResponse> => {
    const config = registerProjectTransaction instanceof FormData 
      ? { headers: { 'Content-Type': 'multipart/form-data' } }
      : {};
    const response: AxiosResponse = await baseAPI.post(
      REGISTER_PROJECT_TRANSACTION_URL,
      registerProjectTransaction instanceof FormData 
        ? registerProjectTransaction 
        : { ...registerProjectTransaction },
      config
    );
    console.log('response', response);
    return response;
  };

  static editProjectTransaction = async (editProjectTransaction: EditProjectTransaction | FormData): Promise<AxiosResponse> => {
    const config = editProjectTransaction instanceof FormData 
      ? { headers: { 'Content-Type': 'multipart/form-data' } }
      : {};
    const response: AxiosResponse = await baseAPI.put(
      EDIT_PROJECT_TRANSACTION_URL,
      editProjectTransaction instanceof FormData 
        ? editProjectTransaction 
        : { ...editProjectTransaction },
      config
    );
    return response;
  };

  static toggleProjectTransactionIsActive = async (
    editProjectTransaction: EditProjectTransaction
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_PROJECT_TRANSACTION_IS_ACTIVE_URL,
      {
        ...editProjectTransaction,
      }
    );
    return response;
  };

  static getProjectTransactionStats = async (params: { organizationId: string; projectId?: string }): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_PROJECT_TRANSACTION_STATS_URL, {
      params,
    });
    return response;
  };

  static deleteProjectTransaction = async (projectTransactionId: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_PROJECT_TRANSACTION_URL}/${projectTransactionId}`
    );
    return response;
  };
}

export default ProjectTransaction;

